export enum Direction4 {
    top,
    right,
    bottom,
    left
}

export enum Direction9 {
    topLeft,
    top,
    topRight,
    right,
    bottomRight,
    bottom,
    bottomLeft,
    left,
    center,
    'top-left' = 0,
    'top-right' = 2,
    'bottom-right' = 4,
    'bottom-left' = 6
}